import KeyValue from '@/api/key_value'

const state = {
  itemGroupTypes: []
}

const getters = {
  itemGroupTypes (getterState) {
    return getterState.itemGroupTypes
  }
}

const mutations = {
  set_item_group_types (mutationState, payload) {
    mutationState.itemGroupTypes = payload
  }
}

const actions = {
  async setItemGroupTypes (context) {
    let itemGroupTypesArr = []
    try {
      const data = await KeyValue.getByKeyID('GROUP_TYPE')
      if (data && data.length > 0) {
        itemGroupTypesArr = data
      }
      context.commit('set_item_group_types', itemGroupTypesArr)
    } catch (err) {
      console.error(err)
    }
  }
}

export default {
  namespaced: false,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/key_value.js